export default "__VITE_ASSET__b38d2a99__"